import React, { ChangeEventHandler, FC, memo, useRef, useState } from 'react';
import classNames from 'classnames';
import Search from '@/public/icon/Search.svg';
import styles from '@/styles/components/search-input.module.scss';
import { useRouter } from 'next/router';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { AppState } from '@/store';
import { changeKeyword } from '@/store/slices/sortFilterSlice';
import Image from 'next/image';

type Props = {
  className?: string;
  placeholder?: string;
  onClick?: (ev: any) => void;
}

const SearchInput: FC<Props> = memo(({ className, placeholder, onClick }) => {
  const [focused, setFocused] = useState(false);
  const router = useRouter();

  const dispatch = useDispatch<any>();
  const { language, keyword } = useSelector((state: AppState) => ({
    language: state.homePage.language,
    keyword: state.sortFilter.keyword
  }), shallowEqual)

  const goToSearch = async (ev: any, value: string) => {
    if(keyword.trim()) {
      typeof onClick === 'function' ? onClick(ev) :
      await router.push({ pathname: `${language.value}/blog/search` });
    }
  }

  const handleKeyDown = async (event: any, value: string) => {
    if (event.key === 'Enter') {
      await goToSearch(event, value);
    }
  };


  return (
    <div className={classNames(styles.Search_Input, className, {
      [styles.Input_Focused]: focused
    })}>
      <input
        value={keyword}
        placeholder={placeholder}
        className={styles.Input}
        onChange={(ev) => dispatch(changeKeyword(ev.target.value))}
        onKeyDown={(e) => handleKeyDown(e, keyword)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
      <span className={styles.Search_Icon} onClick={(e) => goToSearch(e, keyword)} >
        <Image src="/blog/icon/Search.svg"  alt={''} width={16} height={16} />
      </span>
    </div>
  );
});

export default SearchInput;
